export const UPDATE_SUBSCRIBER_ID = 'cboard/subscription/UPDATE_SUBSCRIBER_ID';
export const UPDATE_SUBSCRIPTION = 'cboard/subscription/UPDATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION_ERROR =
  'cboard/subscription/UPDATE_SUBSCRIPTION_ERROR';
export const SHOW_PREMIUM_REQUIRED =
  'cboard/subscription/SHOW_PREMIUM_REQUIRED';
export const HIDE_PREMIUM_REQUIRED =
  'cboard/subscription/HIDE_PREMIUM_REQUIRED';
export const SHOW_LOGIN_REQUIRED = 'cboard/subscription/SHOW_LOGIN_REQUIRED';
export const HIDE_LOGIN_REQUIRED = 'cboard/subscription/HIDE_LOGIN_REQUIRED';

export const NOT_SUBSCRIBED = 'not_subscribed';
export const PROCCESING = 'proccesing';
export const ACTIVE = 'active';
export const CANCELED = 'canceled';
export const CANCELLED = 'cancelled';
export const IN_GRACE_PERIOD = 'in_grace_period';
export const PAUSED = 'paused';
export const EXPIRED = 'expired';
export const ON_HOLD = 'on_hold';
export const UNVERIFIED = 'unverified';

export const REQUIRING_PREMIUM_COUNTRIES = [
  'AT',
  'AU',
  'BE',
  'CA',
  'DK',
  'KY',
  'CZ',
  'EE',
  'FI',
  'GI',
  'GR',
  'HU',
  'IS',
  'JP',
  'LT',
  'MC',
  'NZ',
  'NO',
  'PL',
  'SK',
  'SI',
  'SE',
  'US',
  'FR',
  'DE',
  'IE',
  'IT',
  'LI',
  'LU',
  'NL',
  'PT',
  'SM',
  'ES',
  'CH',
  'GB',
  'VA'
]; // ISO-2 country codes
